<template>
    <!--srccomponentsrectCardindexvuehtmlStart-->

    <div id="defaultId1">
        <div id="gd41bb" class="u1dc85">
            <div id="g35a23" :style="{ backgroundColor: value.color }" class="ud86f5">
                <slot id="g803e6" class="ua68b1" name="icon"> </slot>
            </div>
            <!-- <div id="g4ddec" class="u8dc3b">
        
            </div> -->

            <div id="g3d7e9" class="u1e6ea">

                <div id="g05a8b" class="u5311d">
                    <!-- 公司详情接口 -->
                    <!-- <p>{{ value.title }}</p> -->
                    <!-- :style="{ color: value.color }" -->
                    <span id="g61e77" class="u4856e">{{ value.title }}
                    </span>

                </div>
                <!-- v-show="value.textColor!='-'"  -->
                <div  class="avtiveColor margin-bottom20" :style="{ 'color': textColor(value.textColor) }">
                    {{ value.status=='-'?'':value.status }}
                </div>
            </div>
            <div id="gf214a" class="ua367f">
                <slot id="g803e6" class="ua68b1"> </slot>
            </div>
        </div>
    </div>
    <!--srccomponentsrectCardindexvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart

import textContent from "../text_content/index.vue";
//importEnd

export default {
    name: "",

    props: {
        // srccomponentsrectCardindexvuePropsStart

        // srccomponentsrectCardindexvuePropsEnd

        value: {
            type: Object,
            default: {},
        },
    },

    mounted() {
        // defaultLoad
        // srccomponentsrectCardindexvueMountedStart
        // srccomponentsrectCardindexvueMountedEnd
    },

    components: {
        textContent,
    },
    computed: {

    },
    data() {
        return {
            // insertData
            // srccomponentsrectCardindexvueDataStart
            // srccomponentsrectCardindexvueDataEnd
        };
    },
    methods: {
        textColor(value) {
            if (value == '红')
                return '#F00000'
           else if (value == '黄') {
                return '#FFC000'
            }
           else if (value == '绿') {
                return '#00C924'
            }
            else if (value == '灰') {
                return '#666666'
            }else{
                  return '#1A2332'
            }
            
            //   return this.status === 'green' ? 'green' : 'black';
        },

        houershow() {
            this.$emit("houershow", true);
        },
        houerfalse() {
            this.$emit("houershow", false);
        },

        // srccomponentsrectCardindexvueMethodEnd
    },
};
</script>
<style>
.srccomponentsrectCardindexvuecssStart {}

.u1dc85 {
    display: flex;
    height: 100%;
    background-image: url("../../assets/images/card.png");
    background-position-y: 0;
    background-position-x: 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    flex-direction: column;
    max-height: 37.35rem;
    /* /* width: 420px; */
}

.u8dc3b {
    display: inline-block;
    margin-top: 5.3rem;
    margin-left: 3.6rem;
}

.uab2Spu {
    display: inline-block;
}

.uab2Spu:hover .uAXSGHp {
    -webkit-line-clamp: auto !important;
    /* 限制为两行 */
}

.u1e6ea {
    display: flex;
    justify-content: center;
    border-style: none;
    margin: auto;
    flex-direction: column;
}

.ud86f5 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4.28rem;
    height: 4.28rem;
    margin: 1.78571429rem;
    margin-bottom: 0px;
    /* margin: auto; */
    flex-direction: row;
    border-radius: 50%;
}

.ua68b1 {
    margin: auto;
}

.u5311d {
    margin: 1rem 0rem;
    margin-top: 0px;
    font-size: 1.857142857143rem;

}

.u4856e {
    margin: auto;
    font-family: 'DMSans Bold';
    font-size: 1.857142857143rem;
    /* font-weight: bold; */
}

.ua367f {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    height: auto;
    flex-direction: column;
    /* margin-right: 2em;
        margin-left: 2em; */
    margin-left: 2.71rem;
    margin-right: 2.71rem;
    flex: auto;
    padding-bottom: 2.14rem;
}

.avtiveColor {
    display: flex;
    height: 1.714285714rem;
    align-items: center;
    justify-content: center;
    font-size: 1.2857142857143rem;
}

.srccomponentsrectCardindexvuecssEnd {}
</style>